/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsBaseForSaas extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForSaas");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsBaseForSaas.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsBaseForSaas>): ServiceAccountCredentialsBaseForSaas {
        let obj = Object.assign(new ServiceAccountCredentialsBaseForSaas(), model);
        ServiceAccountCredentialsBaseForSaas.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsBaseForSaas>): ServiceAccountCredentialsBaseForSaas {
        if (!model) return null;
        return ServiceAccountCredentialsBaseForSaas.newInstance(<ServiceAccountCredentialsBaseForSaas> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsBaseForSaas) {
        if (!obj) return;

        models.ServiceAccountCredentialsBaseForSaas.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsBaseForSaas): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsBaseForSaas.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
